module.exports = __webpack_public_path__ + "img/play.be833db6.png";